module.exports =
  printLabel: '/internal/autobagger/printLabel'


// WEBPACK FOOTER //
// ./~/oo-routes/routes/autobagger.coffee